import * as React from "react";
import { LTLOffer } from "@src/types/api";
import LTLOfferCard from "./LTLOfferCard";

interface OffersGridProps {
  offers: LTLOffer[];
  selectedOffers: string[];
  onToggleOffer: (offerId: string) => void;
  onChangeMarginPct?: (offerId: string, marginPct: number) => void;
  onChangeMarginDollars?: (offerId: string, marginDollars: number) => void;
  onChangeMarginMode?: (offerId: string, mode: "percent" | "dollar") => void;
  offerMargins?: Record<string, number>;
  offerMarginModes?: Record<string, "percent" | "dollar">;
  offerMarginDollars?: Record<string, number>;
}

export function OffersGrid({
  offers,
  selectedOffers,
  onToggleOffer,
  onChangeMarginPct,
  onChangeMarginDollars,
  onChangeMarginMode,
  offerMargins = {},
  offerMarginModes = {},
  offerMarginDollars = {},
}: OffersGridProps) {
  const uniqueOffers = offers.filter(
    (offer, index, arr) => arr.findIndex((o) => o.id === offer.id) === index
  );
  const sortedOffers = [...uniqueOffers].sort((a, b) => a.price - b.price);

  return (
    <div className="offers-grid">
      {sortedOffers.map((offer: LTLOffer, index: number) => {
        const offerId = offer.id || `offer-${index}`;

        return (
          <LTLOfferCard
            key={offerId}
            offerId={offerId}
            carrierName={offer.carrierName}
            serviceLevel={offer.serviceLevel}
            price={offer.price}
            transitDays={offer.transitTime}
            scac={offer.scac || undefined}
            isSelected={selectedOffers.includes(offerId)}
            onToggle={() => onToggleOffer(offerId)}
            marginMode={offerMarginModes[offerId] ?? offer.marginInputMode ?? "percent"}
            marginPct={offerMargins[offerId] ?? offer.marginPct ?? 0}
            marginDollars={offerMarginDollars[offerId] ?? offer.marginDollars ?? 0}
            onMarginPctChange={(marginPct) => onChangeMarginPct?.(offerId, marginPct)}
            onMarginDollarsChange={(d) => onChangeMarginDollars?.(offerId, d)}
            onMarginModeChange={(mode) => onChangeMarginMode?.(offerId, mode)}
            isBestRate={false}
          />
        );
      })}
    </div>
  );
}
